import type { TextTemplatePlaceholder } from "@exonn/js-sdk";
import { Flex } from "src/components/Flex.tsx";
import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { ChipV2 } from "src/components/ChipV2/ChipV2.tsx";
import React from "react";

export const Placeholders = ({
  placeholders = [],
  onSelectPlaceholder,
}: {
  placeholders?: TextTemplatePlaceholder[];
  onSelectPlaceholder?: (placeholder: TextTemplatePlaceholder) => void;
}) => {
  if (placeholders.length === 0) {
    return null;
  }
  return (
    <Flex gap={"5px"} flexWrap={"wrap"}>
      {placeholders.map((placeholder, index) => (
        <TooltipV2
          key={index}
          disabled={!placeholder.description}
          content={placeholder.description}
        >
          <ChipV2
            skin={"grey"}
            onClick={() => {
              onSelectPlaceholder?.(placeholder);
            }}
            label={placeholder.label}
          />
        </TooltipV2>
      ))}
    </Flex>
  );
};
